export default "__VITE_ASSET__uE7fZIy7__"